import { isDesktop } from 'react-device-detect'

import { Skeleton } from '@src/quince-components/src'

import styles from './CollectionFilters.module.scss'

const CollectionFilterLoader = () => {
  return (
    <div className={styles.filterSectionLoader}>
      <div className={styles.filterSectionLoaderSkeletonContainer}>
        {new Array(isDesktop ? 8 : 4).fill(0).map((_, index) => (
          <Skeleton key={index} className={styles.filterSectionLoaderSkeleton} />
        ))}
      </div>
      <Skeleton className={styles.filterSectionSortByLoaderSkeleton} />
    </div>
  )
}

export default CollectionFilterLoader
